import { axiosInstance } from '@/rest'

/**
 * Creates an API interface for interacting with Plaid.
 */
const createPlaidApi = () => {
  return {
    /**
     * Creates a link_token and pass the temporary token to your app's client.
     * @returns {Promise<LinkTokenModel>}
     */
    createLinkToken: () => axiosInstance.post('plaid/create_link_token'),
    /**
     * Exchange the public_token for a permanent access_token and item_id for the new Item.
     * @param {PublicTokenModel} body
     * @returns {Promise<PublicTokenModel>}
     */
    exchangePublicToken: (body) =>
      axiosInstance.post('plaid/exchange_public_token', body),

    createProcessorToken: (body) =>
      axiosInstance.post('plaid/exchange_and_create_processor_token', body),
  }
}

const plaidApi = createPlaidApi()

export { plaidApi }

/**
 * @typedef {Object} LinkTokenModel
 * @property {string} link_token - short-lived, one-time use token that authenticates your app with Plaid Link
 * @property {string} expiration
 * @property {string} request_id
 * @property {string} hosted_link_url
 */

/**
 * @typedef {Object} PublicTokenModel
 * @property {string} public_token
 */
